import addPartner from "./addPartner";
(function () {
  // move ldat details on screen size change
  var ldatHasMoved = false;
  var ldatModules = null;
  function moveLdatModule() {
    if (window.innerWidth < 1200 && !ldatHasMoved) {
      ldatModules = $("#ldat_info");
      $(".js-ldat-details-top").prepend(ldatModules);
      ldatHasMoved = true;
    } else if (window.innerWidth >= 1200 && ldatHasMoved) {
      $(".js-ldat-details").prepend(ldatModules);
      ldatHasMoved = false;
    }
  }

  moveLdatModule();
  $(window).resize(function () {
    moveLdatModule();
  });

  // Call filtering and showSection functions on page load if CAP type radio or audience checkboxes have a value selected
  window.addEventListener("DOMContentLoaded", () => {
    const ldat = $("#id_ldat");
    if (ldat.length > 0) {
      const id = ldat.val();
      const capId = $("#current-cap-id").val();
      if (id) {
        getLdat(id, capId);
      }
    }
  });

  $("#id_ldat").change(function () {
    const id = $(this).val();
    const capId = $("#current-cap-id").val();
    getLdat(id, capId, $(this), true);
  });

  function getLdat(id, capId, dropdown, getPartners) {
    var url = `/platform/ldat/${id}/json${
      capId !== "None" && capId !== undefined ? `/${capId}` : ""
    }`;

    $.ajax({
      url: url,
      type: "GET",
      dataType: "json",
      success: function (response) {
        populateData(response.ldat);
        showldatMessage(response, dropdown);
        if (getPartners && response.ldat && response.ldat.partners) {
          showPartners(response.ldat.partners, response.ldat.id);
        }
      },
      error: function (xhr, status, error) {
        console.log(error);
        $("#ldat_info").hide();
        $(".ldat-no-info").show();
      },
    });
  }

  function populateData(ldat) {
    if (ldat) {
      $("#ldat_info").show();
      $(".ldat-no-info").hide();
    } else {
      $("#ldat_info").hide();
      $(".ldat-no-info").show();
    }

    if (ldat && ldat.ldat_description) {
      $("#ldat_description").show();
      $("#ldat_description .description").text(ldat.ldat_description);
    }

    $("#ldat_number").text(ldat.ldat_number);

    if (ldat && ldat.ldat_contact) {
      $("#ldat_contact").show();
      $("#ldat_contact .full_name").text(
        ldat.ldat_contact.first_name + " " + ldat.ldat_contact.last_name
      );
      $("#ldat_contact .role").text(ldat.ldat_contact.role);
      $("#ldat_contact .email")
        .attr("href", "mailto:" + ldat.ldat_contact.email)
        .text(ldat.ldat_contact.email);
      $("#ldat_contact .phone")
        .attr("href", "tel:" + ldat.ldat_contact.phone)
        .text(ldat.ldat_contact.phone);
    } else {
      $("#ldat_contact").hide();
    }

    if (ldat && ldat.relationship_manager) {
      $("#relationship_manager").show();
      $("#relationship_manager .full_name").text(
        ldat.relationship_manager.first_name +
          " " +
          ldat.relationship_manager.last_name
      );
      $("#relationship_manager .email")
        .attr("href", "mailto:" + ldat.relationship_manager.email)
        .text(ldat.relationship_manager.email);
      $("#relationship_manager .phone")
        .attr("href", "tel:" + ldat.relationship_manager.mobile)
        .text(ldat.relationship_manager.mobile);
    } else {
      $("#relationship_manager").hide();
    }
  }

  function showldatMessage(response, dropdown) {
    const parent = $(dropdown).closest(".fieldWrapper");
    const error = parent.find(".fieldErrorWrapper");
    if (response.has_draft_error) {
      error.text(response.has_draft_error);
    } else {
      error.text("");
    }
  }

  function showPartners(partners, ldatId) {
    let previousLdatId = null;
    // Call the addPartner function from addPartner.js and pass the partners data
    partners.forEach((partner) => {
      addPartner(partner, ldatId, previousLdatId);
      previousLdatId = ldatId; // Update previousLdatId for the next iteration
    });
  }
})();
